(() => {
  'use strict';
  // Continue the header backdrop behind iOS Safari's status bar. Safari clips
  // fixed and sticky layers at the page's top edge and only draws the
  // scrolling page behind the status bar, so this layer scrolls with the page
  // and is kept just above the visible top edge.
  const body = document.body;
  if (body.classList.contains('objectiv-homepage') || !CSS.supports('-webkit-touch-callout', 'none')) return;

  const root = document.documentElement;
  const phone = matchMedia('(max-width: 749px), (pointer: coarse) and (max-width: 989px) and (max-height: 500px)');
  const layer = document.createElement('span');
  layer.className = 'obj-scroll-blur';
  layer.setAttribute('aria-hidden', 'true');
  body.append(layer);

  // A scroll timeline moves the layer in step with Safari's own scrolling.
  // Prefer the scripted ScrollTimeline, whose keyframes can be updated
  // reliably; fall back to the CSS timeline, then to a scroll handler.
  let animation;
  if (typeof window.ScrollTimeline === 'function') {
    try {
      animation = layer.animate([], {timeline: new ScrollTimeline({source: root, axis: 'block'}), fill: 'both'});
    } catch (_) {
      animation = null;
    }
  }
  const declared = !animation && CSS.supports('animation-timeline', 'scroll()');
  const timeline = Boolean(animation) || declared;
  if (declared) root.classList.add('obj-scroll-blur-timeline');

  // The timeline maps scroll progress onto a translation of the scroll range.
  // Safari's range is scrollHeight minus the height it scrolls against, which
  // can differ from innerHeight; a wrong range lets the layer drift off the
  // header line. Start from innerHeight and learn the real value from where
  // the timeline actually placed the layer.
  let scrollport = innerHeight, width = innerWidth, frame = 0, calibrating = 0;
  const range = () => Math.max(1, root.scrollHeight - scrollport);
  const applyRange = () => {
    const distance = `${range()}px`;
    if (animation) animation.effect.setKeyframes([{transform: 'translate3d(0, 0, 0)'}, {transform: `translate3d(0, ${distance}, 0)`}]);
    else if (declared) layer.style.setProperty('--obj-scroll-blur-range', distance);
  };
  const calibrate = () => {
    calibrating = 0;
    const y = scrollY, end = root.scrollHeight - innerHeight;
    // Read away from both ends, where rubber-banding clamps the timeline.
    if (!timeline || layer.hidden || y < 40 || y > end - 40) return;
    const offset = new DOMMatrixReadOnly(getComputedStyle(layer).transform).m42;
    if (!(offset > 0) || Math.abs(offset - y) < 0.5) return;
    // offset = y / safariRange × range, so safariRange = y × range / offset.
    scrollport = root.scrollHeight - (y * range()) / offset;
    applyRange();
  };
  const follow = () => {
    if (!timeline) layer.style.transform = `translate3d(0, ${scrollY}px, 0)`;
    else if (!calibrating) calibrating = requestAnimationFrame(calibrate);
  };
  const measure = () => {
    frame = 0;
    layer.hidden = !phone.matches;
    // A new width or orientation changes the scrolled height; relearn it.
    if (innerWidth !== width) {
      width = innerWidth;
      scrollport = innerHeight;
    }
    applyRange();
    follow();
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(measure);
  };

  addEventListener('scroll', follow, {passive: true});
  addEventListener('resize', schedule, {passive: true});
  addEventListener('pageshow', schedule);
  phone.addEventListener('change', schedule);
  new ResizeObserver(schedule).observe(body);
  measure();
})();
